export default __webpack_public_path__ + "static/media/DSC01565.e73826bd.jpg";